const LAYOUT_BACKGROUND_TYPES = {
  COLOR: 'color',
  IMAGE: 'image',
};

const hexToRgb = hex => {
  if (hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }
}

//This was a slight function is a slight tweak of the DomoWeb code found at page/pg-layout/pgLayoutBackgroundUtil.ts
export const getStylesForBackground = (background, width, height) => {
  const containerStyles = {};
  if (!background) return containerStyles;

  containerStyles.color = background.textColor;
  containerStyles.darkMode = background.darkMode;

  if (background.selectedColor) {
    const rgb = hexToRgb(background.selectedColor)
    const alpha = background.alpha || 0;
    containerStyles.backgroundColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
  }

  if (background.type === LAYOUT_BACKGROUND_TYPES.IMAGE) {
    const {
      src,
      x,
      y,
      cropWidth,
      imageWidth,
      imageHeight,
      imageBrightness,
    } = background;
    const overlayRGB = imageBrightness < 4 ? '255,255,255' : '0,0,0';
    const overlayAlpha =
      [0.75, 0.5, 0.25, 0, 0.25, 0.5, 0.75][imageBrightness] || 0;
    const overlayColor = `rgba(${overlayRGB},${overlayAlpha})`;
    const backgroundOverlay = `linear-gradient(${overlayColor},${overlayColor})`;
    containerStyles.backgroundImage = `${backgroundOverlay}, url("${src}")`;
    containerStyles.backgroundRepeat = 'no-repeat';

    const widgetToCropBoxScale = width / cropWidth;
    const imageX = -x * widgetToCropBoxScale;
    const imageY = -y * widgetToCropBoxScale;
    containerStyles.backgroundPosition = `-2px -2px, ${imageX}px ${imageY}px`; // -2 to compensate for borders

    // Convert widget dimensions back into crop box dimensions here in case the widget changes shape and the crop box doesn't update
    const scaleRatios = {
      width: imageWidth ? imageWidth / (width / widgetToCropBoxScale) : 1,
      height: imageHeight ? imageHeight / (height / widgetToCropBoxScale) : 1,
    };
    const newImageWidth = width * scaleRatios.width;
    const newImageHeight = height * scaleRatios.height;
    containerStyles.backgroundSize = `${width + 4}px ${height +
      4}px, ${newImageWidth}px ${newImageHeight}px`; // +4 to compensate for borders
  }
  return containerStyles;
};
